import { render, staticRenderFns } from "./RouteMenu.vue?vue&type=template&id=0161b4e2&lang=html&"
import script from "./RouteMenu.vue?vue&type=script&lang=js&"
export * from "./RouteMenu.vue?vue&type=script&lang=js&"
import style0 from "./RouteMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports